import React from 'react'
import '../CSS/take_test.css'
import take_test from '../img/take_test.png'
import { Link } from 'react-router-dom'
import Button from "@material-tailwind/react/Button";
import H5 from "@material-tailwind/react/Heading5";

const Take_Test = () => {
    return (
        <div className="take_test">
           <div className="take_testInnerDiv">
                <div className="take_testSubInnerDiv">
                    <div className="takeTestImg">
                        <img src={take_test} alt="Brain Img" />
                    </div>
                    <H5>Take the test</H5>
                    <p>Over the last 2 weeks, how often have you been bothered by the following problems?</p>
                    <Link to='/Q1'> 
                        <Button color="lightBlue" size="lg" ripple="light">Continue</Button>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Take_Test
